export default __webpack_public_path__ + "static/media/canada_icon.ebd5facf.png";